var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1028",
    "data-name": "Groupe 1028",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.523,
    height: 48.13,
    viewBox: "0 0 31.523 48.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1706",
    "data-name": "Trac\\xE9 1706",
    d: "M437.514,906.816l7.231-1.344,5.207,5.194.956-7.292,6.549-3.347-6.64-3.162-1.159-7.263L444.6,894.94l-7.265-1.142,3.513,6.461Z",
    transform: "translate(-437.332 -862.536)",
    fill: "#f6c459"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1707",
    "data-name": "Trac\\xE9 1707",
    d: "M429.919,889.494l3.63-2.907L438,887.93l-1.643-4.351,2.653-3.82-4.646.218-2.814-3.7-1.228,4.486-4.392,1.531,3.887,2.554Z",
    transform: "translate(-407.49 -862.536)",
    fill: "#f6c459"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1708",
    "data-name": "Trac\\xE9 1708",
    d: "M443.6,872.3l1.858-2.948,3.482-.141-2.229-2.678.942-3.355-3.236,1.293-2.9-1.933.23,3.477-2.734,2.16,3.378.856Z",
    transform: "translate(-430.496 -862.536)",
    fill: "#f6c459"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRight);
export default __webpack_public_path__ + "static/media/star_right.86ad90a28e5f4580d52f158d6b8314e5.svg";
export { ForwardRef as ReactComponent };